(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-faq"] && !Shopify.designMode) return;
  try {
     
  const accordionOpener = document.querySelectorAll(".accordion-a .details summary");
  accordionOpener.forEach(function(element) {
    element.addEventListener("click", function() {
      this.parentNode.classList.toggle("open");
    });
  }
  );

  } catch(e) { console.error(e); }
})();
})();
